import { CEAppliedConstraintBase } from './ce-applied-constraint-base'


export class CEAppliedConstraint extends CEAppliedConstraintBase {

}